import React, {useRef} from "react";
import ScrollAnimation from "react-animate-on-scroll";
import { Link } from "react-router-dom";

function Paper({ paperData }) {
    const { id, title, date, github, pdf, author, source, filesource } = paperData;

    const getNospaceTitle = (filesource) => {
        let tempArr = filesource.split("/");
        let fileName = tempArr[tempArr.length - 1];
        let getName = fileName.slice(0, -3);
        return getName;
    };
    return (
        <ScrollAnimation
            animateIn="fadeInUp"
            animateOut="fadeInOut"
            animateOnce={true}
        >
            <div className="blog-item rounded bg-white shadow-dark">
                <div className="details">
                    <h4 className="my-0 title">
                        <Link
                            to={`papers/paper-details/${id}/${getNospaceTitle(filesource)}`}
                        >
                            {title}
                        </Link>
                    </h4>
                    <ul className="list-inline meta mb-0 mt-2">
                        <li className="list-inline-item">{date}</li>
                        <li className="list-inline-item">{author}</li>
                        <li className="list-inline-item">{source}</li>
                    </ul>
                    <div>
                        <ul className="list-inline meta mb-0 mt-2">
                            <li className="list-inline-item"><a href={github} style={{textDecoration: 'none'}}><i className="fab fa-github"></i> Code</a> </li>
                            <li className="list-inline-item"><a href={pdf} style={{textDecoration: 'none'}}><i className="fas fa-file-pdf"></i> PDF</a> </li>
                            <li className="list-inline-item"><a href={pdf} style={{textDecoration: 'none'}}><i className="fas fa-eye"></i> Show Abstract</a> </li>
                        </ul>
                    </div>
                </div>
            </div>
        </ScrollAnimation>
    );
}

export default Paper;
